import { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import * as Icon from '@mui/icons-material/';
import ComponentTable from '../../../Components/Table/Index';
import { Button } from '../../../../shared/components/button/Button';
import { Form, Formik, Field } from 'formik';
import { useNavigate } from 'react-router-dom';
import { Column } from '../../../Components/Table/Types';
import {
  UsuarioAtualizar,
  UsuarioCadastrar,
} from '../../../../routes/RoutesNames';
import { IconButton } from '@mui/material';
import UsuarioController from '../../../../controllers/UsuarioController';
import { Loader } from '../../../../shared/components/Loader';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { ButtonMenu } from '../../../../shared/components/ButtonMenu';

interface Row {
  BtnEditar?: JSX.Element;
  BtnExcluir?: JSX.Element;
  usu_id?: number;
  usu_nome?: string;
  usu_login?: string;
}

export default function Usuario() {
  const ref = useRef<HTMLButtonElement>(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const usuarioLogado = useSelector((state: any) => state.Authentication.userId);

  /* [22/10] As licenças, só para ver. Antes este número só existia na configuração do
     banco e dentro da mensagem de recusa - ou seja, a pessoa só descobria o limite quando
     esbarrava nele, depois de preencher o cadastro inteiro. */
  const [licencas, setLicencas] = useState<any>(null);

  /**
   * Redefine a senha de outro usuário: a API gera uma temporária, grava e envia por
   * e-mail, e a pessoa volta para o fluxo de primeiro acesso.
   *
   * A mensagem da API chega inteira porque ela DISTINGUE dois desfechos muito
   * diferentes: "senha redefinida e e-mail enviado" e "senha redefinida mas o e-mail não
   * saiu" - este segundo deixa a pessoa sem conseguir entrar, e quem clicou precisa
   * saber na hora.
   */
  const handleRedefinirSenha = async (item: Row) => {
    const resposta = await UsuarioController.RedefinirSenha(item.usu_id!);
    const falhouEmail = resposta?.Data?.EmailEnviado === false;

    if (resposta?.StatusCode !== 200) {
      toast(resposta?.Data ?? 'Não foi possível redefinir a senha.', {
        type: 'error',
        autoClose: 15000,
      });
      return;
    }

    toast(resposta?.Data?.Mensagem ?? 'Senha redefinida.', {
      type: falhouEmail ? 'warning' : 'success',
      autoClose: falhouEmail ? 20000 : 8000,
    });
  };

  const carregarLicencas = async () => {
    const resposta = await UsuarioController.Licencas();
    const dados = Array.isArray(resposta?.Data) ? resposta.Data[0] : resposta?.Data;

    if (resposta?.StatusCode === 200 && dados) setLicencas(dados);
  };

  const tableColumns: Column[] = [
    // { id: 'BtnEditar', label: '', width: 60, minWidth: 0 },
    // { id: 'BtnExcluir', label: '', width: 60, minWidth: 0 },
    { id: 'Id', label: 'Id', minWidth: 0, align: 'center' },
    { id: 'Nome', label: 'Nome', minWidth: 0 },
    { id: 'Login', label: 'Login', minWidth: 0 },
    { id: 'BtnMenu', label: '', width: 60, minWidth: 0, align: 'right' },
  ];

  const [tableRows, setTableRows] = useState<Row[]>([]);

  useEffect(() => {
    ref?.current?.click();
  }, []);

  const handleNavigation = async (): Promise<void> => {
    navigate(UsuarioCadastrar);
  };

  const handleEditItem = (item: Row, duploClick = false, duploClickId = 0) => {
    if (duploClick) {
      navigate(UsuarioAtualizar.replace(':id', duploClickId.toString()), { state: { duploClick: true } });
    }
    else {
      navigate(UsuarioAtualizar.replace(':id', item.usu_id!.toString()));
    }
  };

  const handleDeleteItem = async (usu_id: number) => {
    //const request: any = { UsuId: usuarioLogado, UsuarioId: usu_id };
    const response = await UsuarioController.Excluir(usu_id);

    if (response.StatusCode === 204) {
      toast('Usuário excluído com sucesso!', {
        type: 'success',
      });
      handleSubmit(initialValues);
    } else {
      toast('Erro ao excluir o usuário!', {
        type: 'error',
      });
    }
    console.log(usu_id);
  };

  const handleSubmit = async (values: any) => {

    const DataRows: any = [];
    setLoading(true);
    const Response = await UsuarioController.Listar(values);
    setLoading(false);
    if (Response.StatusCode === 200 && Response?.Data?.length > 0) {
      Response.Data.map((item: Row) => {
        DataRows.push({
          // BtnEditar: (
          //   <IconButton
          //     onClick={() => handleEditItem(item)}
          //     aria-label='edit'
          //     color='info'
          //     title='Editar'
          //   >
          //     {' '}
          //     <Icon.Edit />
          //   </IconButton>
          // ),
          // BtnExcluir: (
          //   <IconButton
          //     onClick={() => handleDeleteItem(item.usu_id!)}
          //     aria-label='delete'
          //     color='error'
          //     title='Excluir'
          //   >
          //     <Icon.Delete />
          //   </IconButton>
          // ),
          Id: item.usu_id,
          Nome: item.usu_nome,
          Login: item.usu_login,
           BtnMenu: (
                      <ButtonMenu
                        items={[
                          { onClick: () => handleEditItem(item), menu: 'Editar' },
                          {
                            onClick: () => handleRedefinirSenha(item),
                            menu: 'Redefinir senha',
                            // Confirmação obrigatória: a senha ATUAL para de valer no
                            // instante do clique. Sem o aviso, um clique errado tranca a
                            // pessoa fora até o e-mail novo chegar.
                            confirmar:
                              `Redefinir a senha de "${item.usu_nome ?? ''}"? ` +
                              'A senha atual deixa de funcionar na hora, e uma nova é enviada por e-mail.',
                            /* [CORRECAO 03/11/2026] Sem estes dois, o diálogo saía como
                               "CONFIRMAR EXCLUSÃO" com botão vermelho "EXCLUIR" para uma
                               REDEFINIÇÃO — o padrão do componente, que nasceu para
                               exclusão. É o mesmo defeito que o "Gerar Recibo" teve em
                               21/08 e virou chamado; a correção de lá criou estas
                               propriedades, e este item simplesmente não as usou.
                               Quem lê o título e o botão, e não o texto, acha que vai
                               apagar o usuário — e desiste, ou pior, aprende a clicar
                               em EXCLUIR sem ler.

                               `destrutivo` continua true de propósito: a senha atual
                               PARA de valer no clique, então o vermelho é honesto aqui.
                               O que estava errado eram as palavras. */
                            tituloConfirmar: 'Confirmar redefinição de senha',
                            rotuloConfirmar: 'Redefinir senha',
                          },
                          {
                            onClick: () => handleDeleteItem(item.usu_id!),
                            menu: 'Excluir', confirmar: `Excluir o usuário "${item.usu_nome ?? ''}"? Esta ação não pode ser desfeita.`,
                          },
                        ]}
                      />
                    ),
        });

        setTableRows(DataRows);
      });
    } else {
      setTableRows([]);
    }
  };

  const initialValues = {
    UsuarioId: null,
    Nome: '',
    Setor: '',
  };

  useEffect(() => {
    handleSubmit(initialValues);
    // Recarregado junto com a lista: criar ou desativar usuario muda a conta, e um numero
    // parado seria pior do que numero nenhum.
    carregarLicencas();
  }, []);

  return (
    <Loader loading={loading}>
      <Box
        sx={{
          '& .MuiTextField-root': { m: 1, width: '35ch' },
        }}
      >
        <div className={'pb-2'}>
          <HeaderComponent
            className={'mb-6'}
            text={'Listagem de Usuários'}
            ButtonRight={
              <Button
                className={''}
                variant='success'
                onClick={handleNavigation}
                iconStart={<Icon.Add />}
                title={'Incluir'}
              />
            }
          />
          {licencas && (
            <Box
              className={'flex flex-row items-center gap-6 px-3 py-2 mb-2'}
              sx={{ bgcolor: '#F3F3F1', borderRadius: 1 }}
            >
              <span>
                <strong>Usuários contratados:</strong> {licencas.contratadas}
              </span>
              <span>
                <strong>Em uso:</strong> {licencas.em_uso}
              </span>
              <span
                style={{
                  // Zero disponível não é erro, mas muda o que a pessoa pode fazer agora:
                  // o próximo cadastro vai ser recusado. Vale destacar.
                  color: licencas.disponiveis === 0 ? '#E10511' : undefined,
                  fontWeight: licencas.disponiveis === 0 ? 'bold' : undefined,
                }}
              >
                <strong>Disponíveis:</strong> {licencas.disponiveis}
              </span>
              {licencas.nao_contam > 0 && (
                <span style={{ color: '#777' }}>
                  ({licencas.nao_contam} usuário(s) Danysoft não consomem licença)
                </span>
              )}
            </Box>
          )}

          <Box mb={2} />
          <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={handleSubmit}
          >
            {({ errors }) => (
              <Form>
                <Box className={'flex flex-row items-center gap-2'}>
                  <Field
                    //required
                    //error
                    classsName={'col-span-8'}
                    name='UsuarioId'
                    as={TextField}
                    label='Código'
                    type='number'
                    autoComplete='current-password'
                    size={'small'}
                    InputLabelProps={{ shrink: true }}
                  />

                  <Field
                    name='Nome'
                    as={TextField}
                    label='Nome'
                    type='text'
                    error={Boolean(errors?.Nome)}
                    helperText={errors?.Nome}
                    size={'small'}
                    InputLabelProps={{ shrink: true }}
                  />
                  <Box>
                    <IconButton size={'large'} type={'submit'}>
                      <Icon.Search style={{ fontSize: '28px' }} />
                    </IconButton>
                  </Box>
                </Box>

              </Form>
            )}
          </Formik>
        </div>
        <ComponentTable columns={tableColumns} rows={tableRows} onRowDoubleClick={(row) => {
          handleEditItem(row, true, row.Id);
        }} />
      </Box>
    </Loader>
  );
}
